import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import ClientExperienceShell from "../components/ClientExperienceShell";
import { bookingBackgroundGifUrl } from "../../../shared/lib/bookingConfig";
import servicesCatalog from "../../../shared/data/services.json";
import "./styles/ServiceSelectionPage.css";

function ServiceSelectionPage() {
  const [experience, setExperience] = useState(null);
  const [expandedServiceId, setExpandedServiceId] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Choose a Service";

    try {
      setExperience(servicesCatalog);
      setExpandedServiceId("");
      setError("");
    } catch (_loadError) {
      setError("Unable to load services.");
    }
  }, []);

  return (
    <ClientExperienceShell backgroundGifUrl={bookingBackgroundGifUrl} className="client-selection-page">
      <div className="service-selection-overlay" />
      <main className="client-stage-page service-selection-page-content">
        <section className="client-page-header minimal-client-header">
          <div className="minimal-client-header-row">
            <button
              className="back-button"
              aria-label="Back"
              onClick={() => navigate("/")}
              type="button"
            >
              ←
            </button>
            <h1>Services</h1>
          </div>
        </section>

        {error ? <p className="status-message is-error">{error}</p> : null}

        {!experience && !error ? <section className="service-loading-copy">Loading services...</section> : null}

        {experience ? (
          <section className="service-grid service-accordion-list">
            {experience.services.map((service) => (
              <ServiceCard
                key={service.id}
                isExpanded={expandedServiceId === service.id}
                onToggle={() =>
                  setExpandedServiceId((current) => (current === service.id ? "" : service.id))
                }
                service={service}
              />
            ))}
          </section>
        ) : null}
      </main>
    </ClientExperienceShell>
  );
}

export default ServiceSelectionPage;
